<script>
  import {sizeClass}             from '../../../../services/size-class';
  import {driverStore}           from '../../../../stores/filters/driver-store';
  import {showDriverPickerStore} from '../../../../stores/filters/show-driver-picker-store';
  import HelpButton              from '../../../help-button/help-button.svelte';

  const helps = {
    driver: {
      topic: 'Driver',
      description: 'For the best results possible, you should include all drivers.' +
        ' However, if you have a favorite driver you insist on using, you can pick' +
        ' them here.'
    }
  };

  const onShowDriverPicker = (_event) => {
    $showDriverPickerStore = true;
  };
</script>

<style>
  .driver {
    border: 1px solid #333;
    cursor: pointer;
    display: inline-block;
    height: 55px;
    margin-right: 10px;
    position: relative;
    vertical-align: middle;
    width: 91px;
  }

  .driver-name {
    padding: 1px 0 0 3px;
  }

  .driver-img {
    bottom: 2px;
    position: absolute;
    right: 2px;
  }

  .all-drivers {
    background-color: lightgray;
  }
</style>

<template lang="pug" src="./driver-filter.pug"></template>
